import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { User } from "./types";

export function useUser(id?: string) {
  const dispatch = useDispatch();

  return useQuery<ApiResponse<User>>({
    queryKey: ["user", id],
    queryFn: () =>
      dispatch(
        apiThatThrows.getUserProfile.action({
          params: { id },
        })
      ),
    enabled: Boolean(id),
  });
}
